import React, { useEffect, useState, useMemo } from "react";
import classes from "../../../assets/styles/Pages/CouponManagement/CouponManagement.module.css";
import { useAtom } from "jotai";
import { loggedInUser } from "../../../utils/store";
import Loader from "../../../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { get, deleteRecord, put } from "../../../server";
import {
  NFC_FAILURE,
  PRODUCT_DISCOUNT_LINK,
} from "../../../utils/constants/apiUrl";
import showToast from "../../../helpers/showToast";
import { Link } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import { BsThreeDotsVertical } from "react-icons/bs";
import ConfirmationModal from "../../../components/Modals/ConfirmationModal";
import FormInput from "../../../components/Forms/FormInput";
import searchIcon from "../../../assets/images/global_icons/searchicon.svg";
import { useParams } from "react-router-dom";

const NfcFailureList = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [discounts, setDiscounts] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [statusId, setStatusId] = useState(null);
  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  const loadProductDiscount = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      NFC_FAILURE,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      if (data.length > 0) {
        setDiscounts(data);
        const status = data.map((statusValue) => statusValue.status);
        setStatusId(status);
      }
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const filteredItems = useMemo(() => {
    const filtered = discounts.filter(
      (item) =>
        `${item?.user_data?.first_name || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.device_type || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.failure_reason || ""}`.includes(filterText)
    );

    return filtered;
  }, [filterText, discounts]);

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "User Name",
      width: "200px",
      cell: (row) => (
        <p className="globalDetail">{`${row?.user_data?.first_name} ${row?.user_data?.last_name}`}</p>
      ),
    },
    {
      name: "Device Type",
      cell: (row) => <p className="globalDetail">{row?.device_type}</p>,
    },
    {
      name: "NFC Product ID",
      cell: (row) => <p className="globalDetail">{row?.nfc_product_id}</p>,
    },
    {
      name: "Device OS Version",
      width: "200px",
      //cell: (row) => <p className="globalDetail">{row.status}</p>,
      cell: (row) => <p className="globalDetail">{row?.device_os_version}</p>,
    },
    {
      name: "Failure Reason",
      cell: (row) => <p className="globalDetail">{row?.failure_reason}</p>,
    },
    // {
    //   name: "Action",
    //   width: "100px",
    //   right: "true",
    //   cell: (row, index) => (
    //     <div className={classes.action}>
    //       <button
    //         className="btn customActionDropdown dropdown-toggle"
    //         type="button"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
    //       </button>
    //       <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
    //         <li>
    //           <Link
    //             className="dropdown-item"
    //             to={`/productDiscountLink/addEditProductDiscountLink/${row.id}`}
    //           >
    //             Edit
    //           </Link>
    //         </li>
    //         <li>
    //           <Link
    //             className="dropdown-item"
    //             to="#"
    //             onClick={() => updateStatus(row.id)}
    //           >
    //             {/* Inactive */}
    //             {statusId[index] === 1 ? "Inactive" : "Active"}
    //           </Link>
    //         </li>
    //         <li>
    //           <Link
    //             className="dropdown-item"
    //             to="#"
    //             style={{ color: "#E35252" }}
    //             onClick={() => handleDelete(row.id)}
    //           >
    //             Delete
    //           </Link>
    //         </li>
    //       </ul>
    //     </div>
    //   ),
    // },
  ];

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (discountId) => {
    setDeleteId(discountId);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let { status } = await deleteRecord(
      `${PRODUCT_DISCOUNT_LINK}/${deleteId}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await loadProductDiscount();
      setLoading(false);
    }
    setLoading(false);
  };

  const updateStatus = async (discountId) => {
    setLoading(true);
    setStatusId(discountId);
    let newStatus = 1;
    const discountIndex = discounts.findIndex((pkg) => pkg.id === discountId);
    if (discountIndex !== -1) {
      if (statusId[discountIndex] === 1) {
        newStatus = 0;
      }
    }
    const payload = {
      status: newStatus,
    };
    let { status, message } = await put(
      `${PRODUCT_DISCOUNT_LINK}/${discountId}/update/status`,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await loadProductDiscount();
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadProductDiscount();
  }, []);

  return (
    <>
      {!loading ? (
        <div>
          <div className="page_Header">
            <div className="d-flex justify-content-between align-items-md-center align-items-initial flex-md-row flex-column gap-3 mb-3">
              <div className="heading">
                <h1 className="pageTitle">
                  NFC Failure List <span>({discounts.length})</span>
                </h1>
              </div>
              <div className="d-flex align-items-center justify-content gap-2 mb-2">
                <div
                  className="input-group"
                  style={{ maxWidth: "250px", height: "45px" }}
                >
                  <span className="input-group-text bg-white border-end-0">
                    <img
                      src={searchIcon}
                      alt="search"
                      style={{ height: "16px" }}
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Search..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="default-list-table">
            <DataTable
              columns={columns}
              data={filteredItems}
              pagination
              theme="solarized"
            />
          </div>

          <ConfirmationModal
            show={showConfirmationModal}
            handleCloseModal={handleCloseConfirmationModal}
            handleConfirmDelete={handleConfirmDelete}
            confirmTitle="coupon"
          />
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default NfcFailureList;
